import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

// --- Components ---
import Layout from "./components/Layout";

// --- Page Imports ---
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import CreateInvoice from "./pages/Invoice";
import ManageInvoices from "./pages/ManageInvoices";
import InvoiceView from "./pages/InvoiceView";
import EditInvoice from "./pages/EditInvoice";
import ManageDrafts from "./pages/ManageDrafts";
import ManageCustomers from "./pages/ManageCustomers";
import ManageProducts from "./pages/ManageProducts";
import CustomerView from "./pages/CustomerView";
import CustomerEdit from "./pages/CustomerEdit";
import ProductEdit from "./pages/ProductEdit";
import SalesReport from "./pages/SalesReport";
import ManageOutstandings from "./pages/ManageOutstandings";
import SettlePayment from "./pages/SettlePayment";
import ProductCostManager from "./pages/ProductCostManager"; 
import TaxCorrectionPage from "./pages/TaxCorrectionPage"; // <-- ADD THIS LINE
import { Toaster } from 'react-hot-toast';
// Context
import { AuthProvider } from "./context/AuthContext";
import CompanySettings from "./pages/CompanySettings";
// ✅ PrivateRoute passes a 'title' prop to Layout.
const PrivateRoute = ({ children, title }) => {
  const token = localStorage.getItem("token");
  return token ? <Layout title={title}>{children}</Layout> : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster position="top-center" reverseOrder={false} /> 
        <Routes>
          {/* --- Public --- */}
          <Route path="/login" element={<LoginPage />} />

          {/* --- Protected --- */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute title="Dashboard">
                <Dashboard />
              </PrivateRoute>
            }
          />

          {/* Billing */}
          <Route
            path="/billing/new"
            element={
              <PrivateRoute title="Create Invoice">
                <CreateInvoice />
              </PrivateRoute>
            }
          />
          <Route
            path="/billing/manage"
            element={
              <PrivateRoute title="Manage Invoices">
                <ManageInvoices />
              </PrivateRoute>
            }
          />
          <Route
            path="/billing/view/:docno/:finyear"
            element={
              <PrivateRoute title="View Document">
                <InvoiceView />
              </PrivateRoute>
            }
          />
          <Route
            path="/billing/edit/:docno/:finyear"
            element={
              <PrivateRoute title="Edit Invoice">
                <EditInvoice />
              </PrivateRoute>
            }
          />

          {/* Drafts */}
          <Route
            path="/manage-drafts"
            element={
              <PrivateRoute title="Manage Drafts">
                <ManageDrafts />
              </PrivateRoute>
            }
          />
          {/* Use the SAME editor for drafts */}
          <Route
            path="/drafts/edit/:docno/:finyear"
            element={
              <PrivateRoute title="Edit Draft">
                <EditInvoice />
              </PrivateRoute>
            }
          />

          {/* Direct invoice routes (used by ManageDrafts "View") */}
          <Route
            path="/invoices/view/:docno/:finyear"
            element={
              <PrivateRoute title="View Document">
                <InvoiceView />
              </PrivateRoute>
            }
          />
          {/* Optional alias for editing via /invoices/edit */}
          <Route
            path="/invoices/edit/:docno/:finyear"
            element={
              <PrivateRoute title="Edit Document">
                <EditInvoice />
              </PrivateRoute>
            }
          />

          {/* Payments */}
          <Route
            path="/manage-outstandings"
            element={
              <PrivateRoute title="Outstanding Invoices">
                <ManageOutstandings />
              </PrivateRoute>
            }
          />
          <Route
            path="/settle-payment"
            element={
              <PrivateRoute title="Settle Payment">
                <SettlePayment />
              </PrivateRoute>
            }
          />

          {/* Masters */}
          <Route
            path="/masters/customers"
            element={
              <PrivateRoute title="Manage Customers">
                <ManageCustomers />
              </PrivateRoute>
            }
          />
          <Route
            path="/masters/customers/view/:customercode"
            element={
              <PrivateRoute title="View Customer">
                <CustomerView />
              </PrivateRoute>
            }
          />
          <Route
            path="/masters/customers/edit/:customercode"
            element={
              <PrivateRoute title="Edit Customer">
                <CustomerEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/masters/products"
            element={
              <PrivateRoute title="Manage Products">
                <ManageProducts />
              </PrivateRoute>
            }
          />
           <Route
            path="/masters/product-cost"
            element={
              <PrivateRoute title="Update Product Cost">
                <ProductCostManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/masters/products/edit/:prodcode"
            element={
              <PrivateRoute title="Edit Product">
                <ProductEdit />
              </PrivateRoute>
            }
          />
           {/* --- Settings --- */}
          <Route
            path="/settings/company-profile"
            element={
              <PrivateRoute title="Company Settings">
                <CompanySettings />
              </PrivateRoute>
            }
          />
          {/* Reports */}
          <Route
            path="/reports/sales"
            element={
              <PrivateRoute title="Sales Report">
                <SalesReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/tools/tax-correction"
            element={
              <PrivateRoute title="Correct Tax Discrepancies">
                <TaxCorrectionPage />
              </PrivateRoute>
            }
          />

          {/* Fallback */}
          <Route
            path="*"
            element={<Navigate to={localStorage.getItem("token") ? "/dashboard" : "/login"} />}
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
